<template>
  <pr-box :title="titleBox">

    <div slot="buttons-header">
      <v-tooltip top>
        <v-btn icon slot="activator" @click="openNewWindow()">
          <v-icon color="white">launch</v-icon>
        </v-btn>
        <span>Abrir em nova aba</span>
      </v-tooltip>
    </div>

    <v-layout row wrap fill-height>
      <v-flex xs12 sm6 md4 lg4>
        <v-select
          :items="reportGroups"
          v-model="groupId"
          item-text="table_name"
          item-value="id"
          :disabled="(reportGroups.length === 0)"
          label="Selecione um Grupo de Relatórios">
        </v-select>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 v-if="reportGroups.length > 0">
        <iframe :src="zohoReport"
                width="100%"
                height="800px"
                style="border: none;"
                title="Zoho Analytics"></iframe>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 v-else>
        <v-alert :value="true" type="info">
          Nenhum grupo cadastrado para exibir o relatório.
        </v-alert>
      </v-flex>
    </v-layout>
  </pr-box>
</template>

<script>
import CrudMixin from '@/components/mixins/CrudMixin';
import ZohoReportService from '@/features/zoho-report/ZohoReportService';

export default {
  name: 'zoho-report-view',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false,
    },
  },
  watch: {
    groupId() {
      this.getZohoReport();
    },
  },
  data() {
    return {
      zohoReport: null,
      reportGroups: [],
      groupId: null,
    };
  },
  beforeMount() {
    this.loadCombos();
  },
  methods: {
    initCrud() {
      this.serviceType = ZohoReportService;
      this.routerName = 'zoho-report-view';
      this.onSearchInit = false;
    },
    async getZohoReport() {
      try {
        const response = await this.service.request(
          'GET',
          'get-view',
          null,
          { params: { id: this.groupId } },
        );
        this.zohoReport = response.data;
      } catch (e) {
        this.$log.error(e);
      }
    },
    openNewWindow() {
      window.open(this.zohoReport, '_blank');
    },
    async loadCombos() {
      this.reportGroups = await this.service.query();
      if (this.reportGroups.length > 0) {
        this.groupId = this.reportGroups[0].id;
        await this.getZohoReport();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/features/zoho-report/ZohoReportView.vue